import React from "react";
import { Modal, Row, Col } from "antd";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalPricingAreaDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="Pricing Area Detail"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>Pricing Area Detail</p>

        <RowForm>
          <Col span={8}>Area Name</Col>
          <Col span={16}>: {data ? data.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Plat Nomor</Col>
          <Col span={16}>: {data ? data.kodePlat : null}</Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalPricingAreaDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Area/PricingArea/ModalPricingAreaDetail.js